export default __webpack_public_path__ + "static/media/school.88a7719a.png";